// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";
import { getChartType } from "./Types/ChartTypes";

class ChartObject {
	#chartId = null;
	#chartTypeId = null;
	#title = "";
	#position = null;
	#chartValues = "";
	#titleColorHex = "";
	#lastChanged = null;
	#lastChangeAuthorId = null;
	#isDraft = true;
	#isTopTitled = true;

	#companyId = false;
	#isLinked = false;
	#categories = [];
	#notification = true;
	#options = {};

	constructor (props) {
		this.#setValues(props);
		if (props.id || props.chartId)
			this.#notification = false;
		this.#companyId = (props?.companyId || null);
	}

	#setValues(vals) {
		this.#chartId = (vals?.id || vals?.chartId || null);
		this.#chartTypeId = (vals?.chartTypeId || null);
		this.#title = (vals?.title || null);
		this.#position = (vals?.position || 0);
		this.#chartValues = (vals?.chartValues || null);
		this.#titleColorHex = (vals?.titleColorHex || "#000000");
		this.#lastChanged = (vals?.lastChanged || formatDate());
		this.#lastChangeAuthorId = (vals?.lastChangeAuthorId || null);
		this.#isDraft = (vals?.isDraft || false);
		this.#isTopTitled = (vals?.isTopTitled || true);

		if (this.#chartTypeId)
			this.SFChartType = getChartType(this.#chartTypeId);
		return (this.values());
	}

	fetchForEdit() {
		let proms = [
			this.fetchCompanyLink(),
			this.fetchCategories()
		];

		return (Promise.all(proms));
	}

	fetchCompanyLink() {
		let that = this;
		if (!this.#chartId)
			return (Promise.resolve(true));
		let prom = genRequest(
			"charts/" + this.#chartId + "/companies"
		).then((resp) => {
			if (!resp?.length)
				that.#isLinked = false;
			else if (!that.#companyId)
			{
				that.#companyId = resp[0]?.companyId || resp[0]?.id;
				that.#isLinked = true;
			}
		});
		return (prom);
	}

	fetchCategories = () => genRequest("categories/chart/" + this.#chartId).then((resp) => {
		this.#categories = resp;
		return (resp);
	});

	send() {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			that.sendChart()
				.then(() => {
					let proms = [
						this.unlinkCategories()
					];
					return (Promise.all(proms));
				})
				.then(() => {
					return (that.linkCompany());
				}, reject)
				.then(() => {
					return (that.linkCategories());
				}, reject)
				.then(() => {
					resolve(true);
					return (true);
				}, reject);
		});
		return (prom);
	}

	sendChart() {
		let that = this;
		let prom = genRequest(
			`charts${this.#chartId ? "/" + this.#chartId : ""}`,
			this.values(),
			this.#chartId ? "put" : "post"
		).then((resp) => {
			if (!that.#chartId && (resp?.id || resp?.chartId))
				that.#setValues({...that.values(), ...resp, companyId: that.#companyId});
			return (that.values());
		});
		return (prom);
	}

	linkCompany() {
		if (!this.#companyId || !this.#chartId)
			return (Promise.reject("Company link error: No CompanyId or ChartId provided"));
		if (this.#isLinked)
			return (Promise.resolve(true));
		let prom = genRequest(
			"charts/" + this.#chartId + "/companies",
			{
				chartId: this.#chartId,
				companyId: this.#companyId
			},
			"post"
		);
		return (prom);
	}

	notify() {
		if (!this.#notification || !this.#chartId || this.#isDraft)
			return (Promise.resolve(true));
		let prom = genRequest(
			"notifications/chart/" + this.#chartId,
			null,
			"post"
		);
		return (prom);
	}

	unlinkCategories() {
		if (!this.#chartId)
			return (Promise.reject("Categories link error: No ChartId provided"));
		let req = genRequest(
			"charts/" + this.#chartId + "/categories",
			null,
			"delete"
		);
		return (req);
	}

	linkCategories() {
		let proms = this.#categories.map((a) => this.linkCategory(a.id || a.categoryId));
		return (Promise.all(proms));
	}

	linkCategory(catId) {
		if (!catId || !this.#chartId)
			return (Promise.reject("Category link error: No CategoryId or ChartId provided"));
		let req = genRequest(
			"charts/" + this.#chartId + "/categories",
			{
				chartId: this.#chartId,
				categoryId: catId
			},
			"post"
		);
		return (req);
	}

	chartId(setChartId) {
		if (typeof setChartId !== "undefined")
			this.#chartId = setChartId;
		return (this.#chartId);
	}

	chartTypeId(setChartTypeId) {
		if (typeof setChartTypeId !== "undefined")
		{
			this.#chartTypeId = setChartTypeId;
			if (this.#chartTypeId)
				this.SFChartType = getChartType(this.#chartTypeId);
		}
		return (this.#chartTypeId);
	}

	title(setTitle) {
		if (typeof setTitle !== "undefined")
			this.#title = setTitle;
		return (this.#title);
	}

	position(setPosition) {
		if (typeof setPosition !== "undefined")
			this.#position = setPosition;
		return (this.#position);
	}

	chartValues(setChartvalues) {
		if (typeof setChartvalues !== "undefined")
			this.#chartValues = setChartvalues;
		return (this.#chartValues);
	}

	parsedChartValues() {
		let vals = this.chartValues();
		let ret = false;
		try {
			ret = JSON.parse(vals);
		} catch (e) {
			return (false);
		}
		return (ret);
	}

	titleColorHex(setTitleColorHex) {
		if (typeof setTitleColorHex !== "undefined")
			this.#titleColorHex = setTitleColorHex;
		return (this.#titleColorHex);
	}

	lastChanged(setLastChanged) {
		if (typeof setLastChanged !== "undefined")
			this.#lastChanged = setLastChanged;
		return (this.#lastChanged);
	}

	lastChangeAuthorId(setLastChangeAuthorId) {
		if (typeof setLastChangeAuthorId !== "undefined")
			this.#lastChangeAuthorId = setLastChangeAuthorId;
		return (this.#lastChangeAuthorId);
	}

	isDraft(setIsDraft) {
		if (typeof setIsDraft !== "undefined")
			this.#isDraft = setIsDraft;
		return (this.#isDraft);
	}

	isTopTitled(setIsTopTitled) {
		if (typeof setIsTopTitled !== "undefined")
			this.#isTopTitled = setIsTopTitled;
		return (this.#isTopTitled);
	}

	options(key, value, ifNotSetted) {
		if (
			key
			&& typeof value !== "undefined"
			&& (!ifNotSetted || (ifNotSetted && typeof this.#options[key] === "undefined"))
		)
			this.#options[key] = value;
		return (key ? this.#options[key] : this.#options);
	}

	categories(setCats) {
		if (typeof setCats !== "undefined")
			this.#categories = setCats;
		return (this.#categories);
	}

	notification(setNotify) {
		if (typeof setNotify !== "undefined")
			this.#notification = setNotify;
		return (this.#notification);
	}

	values() {
		let ret = {
			chartTypeId: this.#chartTypeId,
			title: this.#title,
			position: this.#position,
			chartValues: this.#chartValues,
			titleColorHex: this.#titleColorHex,
			lastChanged: this.#lastChanged,
			lastChangeAuthorId: this.#lastChangeAuthorId,
			isDraft: this.#isDraft,
			isTopTitled: this.#isTopTitled,
		};
		if (this.#chartId)
			ret.chartId = this.#chartId;
		return (ret);
	}
}

export default ChartObject;
